(function SocialButtons(window) {
  const supportsPopover = () => {
    return HTMLElement.prototype.hasOwnProperty('popover');
  };
  const popoverSupported = supportsPopover();

  window.document.addEventListener('click', (e) => {
    const shareButton = e.target.closest('.tc_socialbuttons__button');

    // share button is clicked
    if (shareButton) {
      const title =
        shareButton.getAttribute('data-target-title') || document.title;
      const url =
        shareButton.getAttribute('data-target-url') || document.location.href;

      // use Web Share API (if supported) and suppress popover
      if (navigator.share) {
        navigator
          .share({
            title: title,
            url: url,
          })
          .catch(console.error);

        e.preventDefault();
      } else {
        // if 'Web share API' is not supported a 'popover' will open automatically
        // - and if native 'popover' isn't supported either, this will emulate it.
        if (!popoverSupported) {
          const id = shareButton.getAttribute('popovertarget');
          const popover = window.document.querySelector(
            `.tc_socialbuttons__popover[id="${id}"]`,
          );
          window.document.body.appendChild(popover);
          popover.setAttribute('data-open', true);
          window.document.onkeydown = (evt) => {
            if (evt.key === 'Escape') {
              popover.removeAttribute('data-open');
            }
          };
        }
      }
    } else {
      let popoverOpen;

      // look for open popover
      if (!popoverSupported) {
        popoverOpen = window.document.querySelector(
          '.tc_socialbuttons__popover[data-open]',
        );
      } else {
        popoverOpen = window.document.querySelector(
          '.tc_socialbuttons__popover:popover-open',
        );
      }

      // handle click events in open popover
      if (popoverOpen) {
        // print button
        const printButton = e.target.closest(
          '.tc_socialbuttons__popover__list__item__action[data-name="print"]',
        );
        printButton && window.print();

        // copy button
        const copyLinkButton = e.target.closest(
          '.tc_socialbuttons__popover__list__item__action[data-name="copy"]',
        );
        if (copyLinkButton) {
          const url = copyLinkButton.getAttribute('data-url');
          copyToClipboard(url);
        }

        // close popover
        if (!popoverSupported) {
          popoverOpen.removeAttribute('data-open');
        } else {
          popoverOpen.hidePopover();
        }
      }
    }
  });

  async function copyToClipboard(url) {
    try {
      await navigator.clipboard.writeText(url);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
})(window);
